import React, { Component } from "react";
import './i18n';
import { withTranslation } from "react-i18next";
import Registration from "./Components/Registration/Registration";

class App extends Component {

  render() {
    const lang = window['lang'];
    const rtl = lang === 'ar' ? true : false;
    return (
      <div className={`App ${rtl ? 'local_ar' : ''}`}>
        <Registration />
      </div>
    )
  }
}

export default withTranslation()(App)